module.exports = __webpack_public_path__ + "img/setUp.09742212.png";